import React from "react";
import Footer from "../Component/Footer";
import imageThree from "../image/imageThree.jpg";
import imageTwo from "../image/imageTwo.jpg";
import imageOne from "../image/laundry-basket-blurred-background-modern-washing-machine_488220-17518 (1).jpg";
function Home() {
  return (
    <main id="tt-pageContent">
      <div id="js-mainSlider">
        <div className="mainSlider-preloader">
          <span className="tt-base-color">Sppinzy</span>Laundry
        </div>
        <div className="mainSlider-wrapper"></div>
      </div>
      <div
        className="lazyload bg-top-left move-top-bottom tt-overflow-hidden"
        data-bg="images/wrapper01.png"
      >
        <div className="container container-fluid-xl">
          <div className="box01">
            <div className="box01__img">
              <img
                src={imageOne}
                className="lazyload"
                data-src="images/img01.jpg"
                alt=""
              />
              <img
                className="tt-arrow lazyload"
                src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                data-src="images/arrow-img-right.png"
                alt=""
              />
              <div className="box01__img-label">
                <div className="tt-text01">25</div>
                years of
                <br />
                experience
              </div>
            </div>
            <div className="box01__content">
              <div className="title-block">
                <div className="title-block__label">
                  More than 25 Years of Experience
                </div>
                <h4 className="title-block__title">
                  We are Passionate About Laundry
                </h4>
              </div>
              <div className="box01__wrapper-img">
                <img
                  src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                  className="lazyload"
                  data-src="images/img01.jpg"
                  alt=""
                />
                <div className="box01__img-label">
                  <div className="tt-text01">25</div>
                  years of
                  <br />
                  experience
                </div>
              </div>
              <p>
                We are professionals in the laundry and dry cleaning business,
                which means we always stay up to date on the latest
                technologies, cleaning methods, and solutions for dealing with
                stains or delicate fabrics. Plus, we maintain the highest
                standards of business integrity by following local and national
                regulations and environmental safety rules. We are passionate
                about the way you think about laundry!
              </p>
              <div className="row row-custom01 no-gutters">
                <div className="col-lg-6">
                  <ul className="tt-list01">
                    <li>100% Customer Satisfaction</li>
                    <li>Free Collection & Delivery</li>
                    <li>Affordable Prices</li>
                    <li>Best Quality</li>
                  </ul>
                </div>
                <div className="col-lg-6">
                  <a href="tel:1(800)765-43-21" className="info01">
                    <div className="info01__icon">
                      <i className="icons-483947"></i>
                    </div>
                    <div className="info01__content">
                      <div className="info01__title">
                        Call for Quality Services
                      </div>
                      <address>1 (800) 765-43-21</address>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="added-info added-info__top row no-gutters-row js-init-carusel-tablet slick-default">
            <a href="contact-areas.html" className="added-info__item col-md-4">
              <div className="added-info__icon icons-806765"></div>
              <div className="added-info__description">
                <h6 className="added-info__title">
                  <span>Save Time & Money</span>
                </h6>
                No more wasted time driving to the laundromats, we pickup and
                deliver for free!
              </div>
            </a>
            <a href="contact.html" className="added-info__item col-md-4">
              <div className="added-info__icon icons-1485715"></div>
              <div className="added-info__description">
                <h6 className="added-info__title">
                  <span>Pay Online in Seconds</span>
                </h6>
                Manage your Press account and billing online from your
                smartphone or computer.
              </div>
            </a>
            <a href="#" className="added-info__item col-md-4">
              <div className="added-info__icon icons-3037040"></div>
              <div className="added-info__description">
                <h6 className="added-info__title">
                  <span>Eco-Friendly</span>
                </h6>
                We use safe and clean perc-free solvents, so you, and the Earth,
                can look good.
              </div>
            </a>
          </div>
        </div>
      </div>
      <div
        className="tt-position-relative bg-top-left move-bottom-top lazyload"
        data-bg="images/wrapper03.png"
      >
        <div>
          <div className="box02 box02__img-left">
            <img
              className="tt-arrow lazyload"
              src={imageTwo}
              data-src="image/arrow-img-right03.png"
              alt=""
              width="710px"
            />
            <div className="box02__content">
              <div className="title-block">
                <div className="title-block__label">
                  [ Laundry service for your business! ]
                </div>
                <h4 className="title-block__title">
                  Commercial Laundry
                  <br />
                  Service
                </h4>
              </div>
              <p>
                Large corporations have determined that there is a financial
                benefit to outsourcing back office work because it saves money.
                Allowing us to do your laundry is cost effective and will allow
                you and your employees to focus on your core business. We offer
                smart solutions to meet your commercial laundry needs. Our
                Commercial Laundry Clients include:
              </p>
              <div className="row tt-list01__top">
                <div className="col-lg-6">
                  <ul className="tt-list01">
                    <li>Salons &amp; Spas</li>
                    <li>Restaurants and Caterers</li>
                    <li>Religious Organizations</li>
                    <li>Daycare centers</li>
                  </ul>
                </div>
                <div className="col-lg-6">
                  <ul className="tt-list01">
                    <li>Assisted Living / Nursing Homes</li>
                    <li>Hotels &amp; Motels</li>
                    <li>Nail Salons</li>
                    <li>Athletic Facilities / Gyms</li>
                  </ul>
                </div>
              </div>
              <div className="box02-list-col"></div>
            </div>
          </div>
        </div>
        <div className="tt-position-relative">
          <div
            className="lazyload tt-obj01-bg"
            data-bg="image/wrapper04.png"
          ></div>
          <div className="no-margin">
            <div className="container container-fluid-lg">
              <div className="title-block text-center">
                <div className="title-block__label">
                  [ Important Information ]
                </div>
                <h4 className="title-block__title">Trusted Laundry Service</h4>
              </div>
              <div className="tabs-default tab-layout01">
                <div className="tt-ajax-tabs">
                  <ul className="nav nav-tabs" role="tablist">
                    <li className="nav-item">
                      <a
                        className="nav-link show active"
                        data-toggle="tab"
                        href="#tt-tab-01"
                        role="tab"
                      >
                        Our Approach
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        href="#tt-tab-02"
                        role="tab"
                        data-ajax-include="ajax-content/tabs-questions-answers.html"
                      >
                        Questions / Answers
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        href="#tt-tab-03"
                        role="tab"
                        data-ajax-include="ajax-content/tabs-why-choose-us.html"
                      >
                        Why Choose Us
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="tab-content">
                  <div
                    className="tab-pane active fade"
                    id="tt-tab-01"
                    role="tabpanel"
                  >
                    <div className="row align-items-lg-center">
                      <div className="col-sm-6 col-lg-5">
                        <h5 className="tab-layout01__title">Our Approach</h5>
                        <p>
                          We approach workforce accommodations with a property
                          development mindset. Our “Develop. Own. Operate.”
                          business model produces integrated solutions that
                          enable clients to focus on their core business.
                        </p>
                        <p>
                          Clients benefit from consistent service delivery with
                          greater cost and quality control as well as more
                          efficient use of their operational and financial
                          resources.
                        </p>
                      </div>
                      <div className="divider-sm d-block d-sm-none"></div>
                      <div className="col-sm-6 col-lg-6 offset-lg-1 text-right">
                        <a
                          href="https://www.youtube.com/watch?v=_sI_Ps7JSEk"
                          className="tt-obj-video js-video-popup"
                        >
                          <img
                            src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                            className="lazyload"
                            data-src="images/video-img01.jpg"
                            alt=""
                          />
                          <div
                            className="btn-video-holder"
                            data-video="https://www.youtube.com/embed/_sI_Ps7JSEk"
                          >
                            <div className="btn-video icons-254434"></div>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div className="added-info02 added-info02__top row">
                      <a
                        href="contact-areas.html"
                        className="added-info02__item col-md-4"
                      >
                        <div className="added-info02__icon icons-3022225"></div>
                        <div className="added-info02__description">
                          <h6 className="added-info02__title">
                            <span>High Quality</span>
                          </h6>
                          We work hard to make sure that the clothes you get
                          back are spotless and ready for action.
                        </div>
                      </a>
                      <a
                        href="contact.html"
                        className="added-info02__item col-md-4"
                      >
                        <div className="added-info02__icon icons-3096677"></div>
                        <div className="added-info02__description">
                          <h6 className="added-info02__title">
                            <span>Cleaner & Greener</span>
                          </h6>
                          We work with the environment in mind. No harsh
                          chemicals.
                        </div>
                      </a>
                      <a href="#" className="added-info02__item col-md-4">
                        <div className="added-info02__icon icons-686308"></div>
                        <div className="added-info02__description">
                          <h6 className="added-info02__title">
                            <span>Happiness Guarantee</span>
                          </h6>
                          If you're not completely satisfied with the wash or
                          dry cleaning, we will re-process your clothes for
                          free!
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="tab-pane"
                    id="tt-tab-02"
                    role="tabpanel"
                  ></div>
                  <div
                    className="tab-pane"
                    id="tt-tab-03"
                    role="tabpanel"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="tt-position-relative">
          <div className="section-indent">
            <div
              className="lazyload tt-obj02-bg"
              data-bg="image/wrapper05.png"
            ></div>
            {/* <div className="container">
              <div className="title-block text-center">
                <div className="title-block__label">[ Affordable Prices ]</div>
                <h4 className="title-block__title">
                  Our Dry Cleaning & Laundry Prices
                </h4>
                <div className="title-block__text">
                  Our prices are simple and affordable which are easy on pocket
                  <br />
                  in comparison with the high street prices
                </div>
              </div>
              <div
                className="slick-default promo03__wrapper"
                data-slick='{"slidesToShow": 4, "autoplaySpeed": 4500, "slidesToScroll": 4, "autoplay":true, "responsive": [{"breakpoint": 1025, "arrows": false, "settings": {"slidesToShow": 2, "slidesToScroll": 2}}, {"breakpoint": 651, "settings": {"slidesToShow": 1, "slidesToScroll": 1}}]}'
              >
                <div className="tt-item">
                  <div className="promo03 js-handler">
                    <div className="promo03__move">
                      <div className="promo03__icon icons-884417"></div>
                      <div className="promo03__title">Shirts Service</div>
                      <div className="promo03__subtitle">
                        Washed and Pressed
                      </div>
                      <div className="promo03__price">
                        <span className="tt-value">$2.00</span>
                      </div>
                      <div className="promo03__show-btn">
                        <a href="#" className="tt-btn">
                          <span className="mask">Order Now</span>
                          <div className="button">Order Now</div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <div className="section-indent">
        <div className="container-fluid no-gutters">
          <div className="box02 box02__img-right">
            <img className="tt-arrow" src={imageThree} alt="" width="710px" />

            <div className="box02__content">
              <div className="title-block">
                <div className="title-block__label">[ Order even faster ]</div>
                <h4 className="title-block__title">Tap. Clean. Deliver.</h4>
              </div>
              <p>
                Download the our app and request our laundry service. Your
                clothes washed, folded and delivered to your doorstep. So go
                ahead and say yes to more time with the family, more happy
                hours, and more slapping the snooze button every morning — we've
                got laundry day covered.
              </p>
              <ul className="tt-list-img tt-list-img__top">
                <li>
                  <a href="#">
                    <img
                      className="lazyload"
                      src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                      data-src="image/img05.png"
                      alt=""
                    />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img
                      className="lazyload"
                      src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                      data-src="image/img06.png"
                      alt=""
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="container section-inner container-fluid-xl no-gutters">
        <div className="tt-promo">
          <div className="tt-promo__descriptions">
            <h6 className="tt-promo__title">
              Quality Service with
              <br className="d-none d-lg-block" />
              Free{" "}
              <span className="tt-base-color">Collection &amp; Delivery</span>
            </h6>
            <p>
              It is our goal to offer you the best possible laundry
              <br />
              and dry cleaning service available.
            </p>
            <address>
              <a href="tel:1(800)7654321">1 (800) 765-43-21</a>
            </address>
          </div>
          <div className="tt-promo__img">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAmkAAAFiAQMAAACXkN3PAAAABlBMVEUAAADq6urlXPy5AAAAAnRSTlMAAQGU/a4AAAA0SURBVHja7cExDQAAAAIgT/snNocbEAAAAAAAAAAAAAAAAAAAAOBJAwAAAAAAAAAAAABwa9XlAAnqWLNnAAAAAElFTkSuQmCC"
              className="lazyload"
              data-src="image/promo-img-01.png"
              alt=""
            />
            <img
              className="tt-arrow lazyload"
              src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
              data-src="image/arrow-img-left.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default Home;
